import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface SizeMeasurementsTableProps {
  valueList: string[][];
}

export const SizeMeasurementsTable = ({ valueList }: SizeMeasurementsTableProps) => {
  const [header, ...body] = valueList;

  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            {header.map((value, index) => (
              <Th key={value} sticky={index === 0} dangerouslySetInnerHTML={{ __html: `<div>${value}</div>` }} />
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row, rowIndex) => (
            <Tr key={row[rowIndex]} border>
              {row.map((cell, cellIndex) => (
                <Td key={cell} sticky={cellIndex === 0} dangerouslySetInnerHTML={{ __html: `<div>${cell}</div>` }} />
              ))}
            </Tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

const TableContainer = styled.div`
  margin-bottom: 24px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  touch-action: pan-x;
  /* 스크롤 이벤트 전파 방지 */
  overscroll-behavior: none;
  pointer-events: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span {
    margin-left: 1px;
    font-size: 10px;
    font-weight: 400;
  }

  th,
  td {
    height: 39px;
  }

  thead {
    tr:first-of-type {
      border-top: 1px solid ${vars.color.fillTertiary};
    }

    tr:last-child {
      border-bottom: 1px solid ${vars.color.fillTertiary};
    }
  }

  tbody {
    tr:last-child {
      border-bottom: 1px solid ${vars.color.fillTertiary};
    }
  }
`;

const Th = styled.th<{ sticky?: boolean }>`
  text-align: center;
  position: sticky;

  ${({ sticky }) =>
    sticky
      ? `left: 0; z-index:1; width:84px; font-size: 13px; font-weight: 600; color: ${vars.color.textPrimary}; background-color: ${vars.color.fillTertiary};`
      : `width: 80px; font-size: 12px; font-weight: 400; color: ${vars.color.textSecondary};`};
`;

const Tr = styled.tr<{ border: boolean }>`
  ${({ border }) => border && `border-bottom: 1px solid ${vars.color.fillTertiary};`}
`;

const Td = styled.td<{ sticky?: boolean }>`
  width: 80px;
  text-align: center;
  font-size: 12px;

  position: sticky;
  ${({ sticky }) =>
    sticky
      ? `left: 0; z-index: 1; font-weight: 600; color: ${vars.color.textPrimary}; background-color: ${vars.color.fillTertiary};`
      : `font-weight: 400; color: ${vars.color.textSecondary}; background-color: ${vars.color.staticWhite};
`}
`;
